export default "__VITE_ASSET__Hcb0XiXQ__"